<mat-toolbar color="primary" style="min-height: 150px;" fxLayout="row" fxLayoutAlign="center center">


    <span id="title">Sabueso</span>

</mat-toolbar>